const { compose } = require('redux');
const { connect } = require('react-redux');
const React = require('react');


const withRootComponentProps = compose(
    connect(({ ssrProps }) => ({ ssrProps })),
    (WrappedComponent, displayName) => {
        const RootComponentProps = ({ ssrProps }) => {
            const props = ssrProps[displayName];

            return <WrappedComponent {...props} />;
        };

        RootComponentProps.displayName = `RootComponentProps(${WrappedComponent.displayName})`;

        return RootComponentProps;
    }
);

module.exports = withRootComponentProps;
